export default __webpack_public_path__ + "static/media/tick.d9cfb76d.png";